// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import HelloController from "./hello_controller"
import SliderController from "./slider_controller"
import SearchController from "./search_controller"
import EventContentController from "./event_content_controller"
import TabsController from "./tabs_controller"
import EventTypeFilterController from "./event_type_filter_controller"
import PostingCheckBulkController from "./posting_check_bulk_controller"
import HallFilterController from "./hall_filter_controller"
import NestedFormController from "./nested_form_controller"
import NinePiecePosterController from "./nine_piece_poster_controller"
import ClipboardController from "./clipboard_controller"
application.register("hello", HelloController)
application.register("slider", SliderController)
application.register("search", SearchController)
application.register("eventContent", EventContentController)
application.register("tabs", TabsController)
application.register("event-type-filter", EventTypeFilterController)
application.register("posting-check-bulk", PostingCheckBulkController)
application.register("hall-filter", HallFilterController)
application.register("nested-form", NestedFormController)
application.register("nine-piece-poster", NinePiecePosterController)
application.register("clipboard", ClipboardController)
